import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/449718661b99bc1dc524f4d7110e20bf/381ff4af4f0606b60234e65040da7b54.png" 
              alt="Logo" 
              className="h-20 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('portfolio')} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              {t('nav.portfolio')}
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('blog')} className={`text-sm font-medium transition-colors hover:text-teal-500 ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              {t('nav.blog')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors whitespace-nowrap">
              {t('nav.contact')}
            </button>
          </div>

          <button 
            className="lg:hidden text-gray-800"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${isScrolled ? 'text-gray-800' : 'text-white'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col space-y-3 px-4 py-3">
              <button onClick={() => scrollToSection('home')} className="text-sm font-medium text-gray-800 hover:text-teal-500 text-left">{t('nav.home')}</button>
              <button onClick={() => scrollToSection('services')} className="text-sm font-medium text-gray-800 hover:text-teal-500 text-left">{t('nav.services')}</button>
              <button onClick={() => scrollToSection('portfolio')} className="text-sm font-medium text-gray-800 hover:text-teal-500 text-left">{t('nav.portfolio')}</button>
              <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-800 hover:text-teal-500 text-left">{t('nav.about')}</button>
              <button onClick={() => scrollToSection('blog')} className="text-sm font-medium text-gray-800 hover:text-teal-500 text-left">{t('nav.blog')}</button>
              <button onClick={() => scrollToSection('contact')} className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors whitespace-nowrap">{t('nav.contact')}</button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
